import { createReducer } from '@reduxjs/toolkit';

import getOrderedPartTypeList from '../../thunks/general/getOrderedPartTypeList';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const getOrderedPartsListReducer = createReducer(initialState, {
  [getOrderedPartTypeList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getOrderedPartTypeList.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    data: data.map(({ part_type: type }) => ({ label: type, value: type })),
    loading: false,
  }),
  [getOrderedPartTypeList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getOrderedPartsListReducer;
